import { Box, Grid, Typography, useTheme, Switch, FormControlLabel, Radio, RadioGroup, Checkbox, switchClasses, Popover, Chip, TextField, FormHelperText } from "@mui/material";
import { useForm, Controller, Control } from "react-hook-form";
import Button from "../../common/Button";
import { AddCircleOutlineOutlined, CancelOutlined, SaveOutlined, ShoppingCart, KeyboardArrowDownOutlined } from "@mui/icons-material";
import CustomTextField from "../../common/CustomTextField";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import {
    MainErrorInfo,
    SingleAlertInfo,
    setMainErrorObj,
    setSingleAlertObj,
} from "../../../redux/slice/commonSlice"; //CS-1672 - Removed fetchAppConfigList and useCommonReducer imports
import { useLocation } from "react-router-dom";
import React from "react";
import CustomPatternTextField from "../../common/CustomPatternTextField";
import { CodeTable, fetchAllCodeTablesValues, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import { editManufacturerData, fetchManufacturerDataById, saveManufacturers, useManufacturerListSlice } from "../../../redux/slice/manufacturer/ManufacturerSlice";
import { CAN_ACCESS_APPLICATION, CAN_ACCESS_NETSUITE_CONFIG, CAN_ACCESS_STRIPE_CONFIG, INVOICE_DUE_DATE, INVOICE_DUE_DAYS, MSG_NO_LIVE_SERVICE_AGREEMENT_FOR_MANUFACTURER, PRODUCT_CATEGORY, TEMPLATE_LEVELS, PHARMACY_CONFIG_BILL_TO_PATIENT, PHARMACY_CONFIG_BILL_TO_PRACTICE_PROVIDER } from "../../../constants/applicationConstants";
import useToken from "../../../hooks/useToken";
import CustomNumberField from "../../common/CustomNumberField";
import CustomCurrencyField from "../../common/CustomCurrencyField";
import CustomMultipleDropDown from "../../common/CustomMultipleDropDown";
import CustomDatePicker from "../../common/CustomDatePicker";
import moment from "moment";
import { useNavigation } from "../../../hooks/useNavigation";
import PracticeTemplatePopup from "../practice/PracticeTemplatePopup";
import { fetchManufacturerTemplatesData, usePracticeEditSlice, inactivateManufacturerTemplateData } from "../../../redux/slice/practice/practiceEditSlice";
import { fetchTemplateById } from "../../../redux/slice/practiceSlice";
import { downloadBase64File, getCategoryDisplayLabel, pharmacyBillToFromConfig, toPharmacyConfig } from "../../../utils/Utility";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import CustomTable from "../../common/CustomTable";
import { DoDisturbAltOutlined, DownloadOutlined, Edit } from "@mui/icons-material";
import CustomIconButton from "../../common/CustomIconButton";
import IconDetailToolBar from "../../common/IconDetailToolBar";
import { selectIsValueFoundInToken } from "../../../redux/slice/authSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { styled } from '@mui/material/styles';
import ModernStyledRadio from "../../common/CutomModernStyledRadio";
import { tokens } from "../../../theme";
import FieldFocusPopup from "../../common/FieldFocusPopup";
import { useModalStyles } from "../../common/useModalStyles";
import { SectionHeader } from "../../ui/ContentSection";
import {
    MailOutlined,
    TuneOutlined,
    DescriptionOutlined,
    PaymentOutlined,
    CloudSyncOutlined,
    LocalPharmacyOutlined,
    AccountTreeOutlined,
} from "@mui/icons-material";

//CS-1563
export const SwitchTextTrack = styled(Switch)({
    width: 80,
    height: 48,
    padding: 8,
    [`& .${switchClasses.switchBase}`]: {
        padding: 11,
        color: "#ff6a00",
        "&.Mui-disabled": {
            color: "#bdbdbd",
        },
    },
    [`& .${switchClasses.thumb}`]: {
        width: 26,
        height: 26,
        backgroundColor: "#fff",
    },
    [`& .${switchClasses.track}`]: {
        background: "linear-gradient(to right,rgb(161, 161, 161),rgb(84, 84, 84))",
        opacity: "1 !important",
        borderRadius: 20,
        position: "relative",
        "&:before, &:after": {
            display: "inline-block",
            position: "absolute",
            top: "50%",
            width: "50%",
            transform: "translateY(-50%)",
            color: "#fff",
            textAlign: "center",
            fontSize: "0.75rem",
            fontWeight: 500,
        },
        "&:before": {
            content: '"ON"',
            left: 4,
            opacity: 0,
        },
        "&:after": {
            content: '"OFF"',
            right: 4,
        },
    },
    [`&.Mui-disabled .${switchClasses.track}`]: {
        background: "linear-gradient(to right,rgb(189, 189, 189),rgb(158, 158, 158))",
        "&:before, &:after": {
            color: "#9e9e9e",
        },
    },
    [`& .${switchClasses.checked}`]: {
        [`&.${switchClasses.switchBase}`]: {
            color: "#185a9d",
            transform: "translateX(32px)",
            "&:hover": {
                backgroundColor: "rgba(24,90,257,0.08)",
            },
            "&.Mui-disabled": {
                color: "#bdbdbd",
                transform: "translateX(32px)",
            },
        },
        [`& .${switchClasses.thumb}`]: {
            backgroundColor: "#fff",
        },
        [`& + .${switchClasses.track}`]: {
            background: "linear-gradient(to right,rgb(0, 196, 88),rgb(0, 97, 29))",
            "&:before": {
                opacity: 1,
            },
            "&:after": {
                opacity: 0,
            },
        },
        [`&.Mui-disabled + .${switchClasses.track}`]: {
            background: "linear-gradient(to right,rgb(189, 189, 189),rgb(158, 158, 158))",
            "&:before, &:after": {
                color: "#9e9e9e",
            },
            "&:before": {
                opacity: 1,
            },
            "&:after": {
                opacity: 0,
            },
        },
    },
});
//

/**
 * Normalises a backend flag to a boolean. The API returns isPharmacy as a real
 * boolean; the string / numeric forms are accepted so the toggle still reads
 * correctly if it ever arrives as "Y" or 1 like the other config flags.
 */
const toBooleanFlag = (value: any): boolean =>
    value === true || value === 1 || value === "1" || value === "Y" || value === "y" || value === "true";

const cartOptions = [
    { 
        value: "Option 1", 
        label: "Option 1",
        description: "Select this when products are ordered by daily supply requirements. The system will show products based on the selected daily supply.",
        icon: <ShoppingCart />,
    },
    { 
        value: "Option 2", 
        label: "Option 2",
        description: "Select this when products are ordered by usage type. The system will show products based on the selected usage type.",
        icon: <ShoppingCart />,
    }
];

const pharmacyBillToOptions = [
    { value: PHARMACY_CONFIG_BILL_TO_PRACTICE_PROVIDER, label: "Practice / Provider" },
    { value: PHARMACY_CONFIG_BILL_TO_PATIENT, label: "Patient" },
];

/** Match CustomCheckbox / CustomRadioButton color on this screen only (dark → secondary). */
const pharmacyBillToControlColor = (mode: "light" | "dark"): "primary" | "secondary" =>
    mode === "dark" ? "secondary" : "primary";

/** Same green as CustomCheckbox on tissue tracking (not page accent / primary teal). */
const pharmacyBillToIconColor = (mode: "light" | "dark", colors: ReturnType<typeof tokens>) =>
    mode === "dark" ? colors.primary[200] : colors.primary[300];

/** Restore CustomCheckbox look inside modernFormFieldsSx (that tints all MuiSvgIcon icons). */
const pharmacyBillToControlsSx = (checkedColor: string) => ({
    "& .MuiCheckbox-root, & .MuiRadio-root": {
        color: checkedColor,
        "&.Mui-checked": {
            color: checkedColor,
        },
        "& .MuiSvgIcon-root": {
            color: "inherit !important",
        },
    },
});
export type ManufacturerCreateObj = {
    manufacturerId: string;
    manufacturerName: string;
    contactPhone: string;
    v3PayDay?:number|null;
    v3PayMonth?:number|null;
    agencyPayDay?:number|null;
    agencyPayMonth?:number|null;
    inactiveDate?:string|undefined;
    notificationEmail: {
        ivr_info: any;
        order_info: any;
        return_info: any;
        tissue_info: any;
        product_agreement_info: any;
    }
    customConfig: {
        invoice_due_date: string | null;
        invoice_net_days: string | null;
        cc_authorized_practice_user: string | null;
        provider_signature_required: string | null;
        template_level: string | null; //CS-1518
    };
    //CS-1563
    stripeConfig: {
        stripe_integration: boolean | null;
        connected_account_id: string | null;
        payment_method: string[] | null;
        platform_fee_applicable: boolean | null;
        platform_fee_card_percent: number | null;
        platform_fee_card_additional: number | null;
        platform_fee_us_bank_account_percent: number | null;
        platform_fee_us_bank_account_max_charge: number | null;
    };
        netsuiteConfig: {
        netsuite_integration: boolean | null;
        connected_customer_id: number | null;
        consumer_key: string | null;
        consumer_secret: string | null;
        access_token: string | null;
        token_secret: string | null;
        realm: string | null;
        post_sales_order_api_url: string | null;
    };
    isPharmacy?: boolean;
    agreementGrouping?: boolean;
    liveServiceAgreementPresent?: boolean;
    pharmacyBillToDisplay?: string[];
    pharmacyBillToDefault?: string;
    miscConfig?: {
        billTo?: { enabledValues?: string[]; defaultValue?: string };
    };
}

const CreateMaufacturer = () => {
    const location = useLocation();
    const isEditing = Boolean(location.state?.mfrData);

    const {
        control,
        handleSubmit,
        reset,
        setValue,
        getValues,
        watch,
        trigger,
        clearErrors,
        formState: { errors, isValid },
    } = useForm<ManufacturerCreateObj>({ mode: 'onChange' });
    const dispatch = useAppDispatch();
    const { navigate } = useNavigation();
    const theme = useTheme()
    const colors = tokens(theme.palette.mode);
    const { tokens: mTokens, isDark, primaryBtnSx, cancelBtnSx } = useModalStyles();
    const billToCheckColor = pharmacyBillToIconColor(theme.palette.mode, colors);
    const billToControlsSx = useMemo(
        () => pharmacyBillToControlsSx(billToCheckColor),
        [billToCheckColor]
    );

    /* Modern field styling applied once across the whole form — same rounded
       inputBg/accent-focus look as Product.tsx/CreatePatient.tsx, scoped via
       MUI's own .Mui-error/.Mui-focused classes so every field/dropdown/date
       picker/chip-input in this form matches without per-field sx wiring.
       Built-in floating labels are hidden — a manual FieldLabel is rendered
       above each field instead, matching CreatePatient.tsx's field layout. */
    const modernFormFieldsSx = {
        "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
            backgroundColor: `${mTokens.inputBg} !important`,
            borderRadius: "10px !important",
            fontSize: "0.85rem",
            color: mTokens.textPrimary,
            minHeight: "40px !important",
            boxShadow: isDark ? "none" : "0 1px 3px rgba(0,0,0,0.06)",
        },
        /* 40px / "8px 12px" is CustomTextField's own canonical size="small"
           sizing (see SIZE_STYLE_MAP) — every other field type is forced to
           match it exactly here so nothing on the page looks taller. */
        "& .MuiOutlinedInput-root:not(.MuiAutocomplete-inputRoot)": {
            height: "40px !important",
        },
        /* Autocomplete-based dropdowns (e.g. Payment Method multi-select) —
           same compact baseline as every other field, normal wrap behavior. */
        "& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root": {
            padding: "3px 8px !important",
            minHeight: "40px !important",
        },
        "& .MuiAutocomplete-input": {
            padding: "4.5px 4px !important",
        },
        "& .MuiOutlinedInput-root fieldset, & .MuiOutlinedInput-notchedOutline": {
            borderColor: `${mTokens.inputBorder} !important`,
            legend: { display: "none" },
        },
        "& .MuiOutlinedInput-notchedOutline": { top: 0 },
        "& .MuiOutlinedInput-root": { transition: "border-color 0.18s" },
        "& .MuiOutlinedInput-root:hover fieldset": {
            borderColor: `${mTokens.accent} !important`,
        },
        "& .MuiOutlinedInput-root.Mui-focused fieldset": {
            borderColor: `${mTokens.accent} !important`,
            borderWidth: "1px !important",
        },
        "& .MuiOutlinedInput-root.Mui-focused": {
            boxShadow: isDark ? "none" : "0 0 0 3px rgba(20,184,166,0.12)",
        },
        "& .MuiOutlinedInput-root.Mui-error fieldset": {
            borderColor: `${mTokens.error} !important`,
        },
        /* Unified disabled look — whole field fades as one flat block instead
           of MUI's default per-part opacity, which reads as patchy/ghosted. */
        "& .MuiOutlinedInput-root.Mui-disabled": {
            backgroundColor: `${isDark ? "rgba(255,255,255,0.015)" : "#f1f5f9"} !important`,
            opacity: 0.55,
        },
        "& .MuiOutlinedInput-root.Mui-disabled fieldset, & .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: `${mTokens.border} !important`,
        },
        "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: mTokens.textSecondary,
            color: mTokens.textSecondary,
        },
        "& .MuiInputLabel-root": { display: "none" },
        "& .MuiFormControlLabel-label": {
            fontSize: "0.88rem",
            fontWeight: 600,
            color: mTokens.textPrimary,
        },
        "& .MuiFormHelperText-root": {
            color: mTokens.textSecondary,
            "&.Mui-error": { color: mTokens.error },
        },
        "& .MuiInputBase-input": {
            color: mTokens.textPrimary,
            fontSize: "0.85rem",
            backgroundColor: "transparent !important",
            padding: "8px 12px !important",
        },
        "& .MuiSvgIcon-root": { color: mTokens.textSecondary },
        "& .MuiChip-root": {
            height: "24px !important",
            borderRadius: "999px",
            backgroundColor: isDark ? "rgba(20,184,166,0.16)" : "rgba(13,148,136,0.12)",
            color: `${mTokens.accent} !important`,
            border: `1px solid ${isDark ? "rgba(20,184,166,0.26)" : "rgba(13,148,136,0.25)"}`,
            fontWeight: 600,
            fontSize: "0.72rem",
            margin: "2px !important",
            transition: "background-color 0.15s ease",
            "&:hover": {
                backgroundColor: isDark ? "rgba(20,184,166,0.24)" : "rgba(13,148,136,0.18)",
            },
        },
        "& .MuiChip-label": {
            padding: "0 6px 0 10px",
        },
        "& .MuiChip-deleteIcon": {
            color: isDark ? "rgba(20,184,166,0.6)" : "rgba(13,148,136,0.55)",
            fontSize: "16px",
            margin: "0 4px 0 -4px",
            "&:hover": {
                color: isDark ? "rgba(20,184,166,0.95)" : "rgba(13,148,136,0.9)",
            },
        },
    };

    const fieldLabelSx = {
        fontSize: "0.8rem",
        fontWeight: 600,
        color: mTokens.textSecondary,
        mb: 0.5,
    };

    // Modernizes the DatePicker's calendar popup (CustomDatePicker is shared
    // across many pages, so this is passed in per-instance via slotProps
    // rather than changing that component's own defaults).
    const datePickerSlotProps = {
        desktopPaper: {
            sx: {
                mt: 1,
                borderRadius: "16px",
                border: `1px solid ${mTokens.border}`,
                backgroundColor: mTokens.bg,
                backgroundImage: "none",
                boxShadow: isDark ? "0 20px 60px rgba(0,0,0,0.5)" : "0 20px 60px rgba(15,23,42,0.15)",
                "& .MuiPickersCalendarHeader-root": { color: mTokens.textPrimary },
                "& .MuiPickersCalendarHeader-label": { fontWeight: 700 },
                "& .MuiPickersArrowSwitcher-button": { color: mTokens.textSecondary },
                "& .MuiPickersArrowSwitcher-button:hover": { backgroundColor: `${mTokens.accent}18`, color: mTokens.accent },
                "& .MuiDayCalendar-weekDayLabel": { color: mTokens.textSecondary, fontWeight: 600 },
                "& .MuiPickersDay-root": {
                    borderRadius: "10px",
                    fontSize: "0.82rem",
                    color: mTokens.textPrimary,
                    "&:hover": { backgroundColor: `${mTokens.accent}18` },
                },
                "& .MuiPickersDay-root.Mui-selected": {
                    backgroundColor: `${mTokens.accent} !important`,
                    color: "#fff !important",
                    fontWeight: 700,
                    "&:hover, &:focus": { backgroundColor: "#0d9488 !important" },
                },
                "& .MuiPickersDay-today:not(.Mui-selected)": {
                    borderColor: `${mTokens.accent} !important`,
                },
                "& .MuiPickersYear-yearButton.Mui-selected, & .MuiPickersMonth-monthButton.Mui-selected": {
                    backgroundColor: `${mTokens.accent} !important`,
                    color: "#fff !important",
                },
                "& .MuiPickersDay-root.Mui-disabled": { color: mTokens.textSecondary, opacity: 0.4 },
            },
        },
    };

    // Groups a toggle with the fields it controls into one bordered panel that
    // visibly lights up (accent border/tint) when the toggle is on, so it's
    // obvious at a glance which fields belong to which switch.
    const toggleGroupSx = (isOn: boolean) => ({
        borderRadius: "14px",
        border: `1px solid ${isOn ? `${mTokens.accent}55` : mTokens.border}`,
        backgroundColor: isOn ? `${mTokens.accent}0a` : (isDark ? "rgba(255,255,255,0.015)" : "#f8fafc"),
        p: { xs: 1.5, sm: 2 },
        transition: "border-color 0.2s ease, background-color 0.2s ease",
    });

    const FieldLabel = ({ children, required, disabled }: { children: React.ReactNode; required?: boolean; disabled?: boolean }) => (
        <Typography sx={{ ...fieldLabelSx, opacity: disabled ? 0.45 : 1, transition: "opacity 0.18s ease" }}>
            {children}
            {required && <Box component="span" sx={{ color: mTokens.accent, ml: 0.3 }}>*</Box>}
        </Typography>
    );

    // Compact "N emails" summary field — click opens a small popup with the
    // full wrapped chip list + an input to add/remove entries, instead of
    // showing every chip inline (which balloons or scrolls awkwardly when
    // there are many). Kept local to this page — CustomEmailChipField is
    // shared with 3 other pages, so this doesn't touch that component.
    const EmailChipSummaryField = ({ control: fieldControl, controllerName, disabled }: { control: Control<any>; controllerName: string; disabled?: boolean }) => {
        const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
        const [draft, setDraft] = useState("");
        const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        return (
            <Controller
                name={controllerName}
                control={fieldControl}
                render={({ field }) => {
                    const emails: string[] = field.value || [];
                    const open = Boolean(anchorEl);

                    const commitDraft = () => {
                        const trimmed = draft.trim();
                        if (trimmed && isValidEmail(trimmed) && !emails.includes(trimmed)) {
                            field.onChange([...emails, trimmed]);
                        }
                        setDraft("");
                    };

                    const removeEmail = (email: string) => {
                        field.onChange(emails.filter((e) => e !== email));
                    };

                    return (
                        <>
                            <Box
                                onClick={(e) => !disabled && setAnchorEl(e.currentTarget)}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1,
                                    height: "40px",
                                    borderRadius: "10px !important",
                                    border: `1px solid ${mTokens.inputBorder}`,
                                    backgroundColor: `${mTokens.inputBg} !important`,
                                    px: 1.5,
                                    cursor: disabled ? "not-allowed" : "pointer",
                                    opacity: disabled ? 0.55 : 1,
                                    transition: "border-color 0.18s ease",
                                    "&:hover": disabled ? {} : { borderColor: mTokens.accent },
                                }}
                            >
                                <Typography noWrap sx={{ fontSize: "0.85rem", color: emails.length ? mTokens.textPrimary : mTokens.textSecondary }}>
                                    {emails.length === 0 ? "No emails added" : emails.length === 1 ? emails[0] : `${emails[0]} +${emails.length - 1} more`}
                                </Typography>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, flexShrink: 0 }}>
                                    {emails.length > 0 && (
                                        <Box
                                            sx={{
                                                px: 0.9,
                                                height: 18,
                                                display: "flex",
                                                alignItems: "center",
                                                borderRadius: "999px",
                                                backgroundColor: isDark ? "rgba(20,184,166,0.18)" : "rgba(13,148,136,0.14)",
                                                color: mTokens.accent,
                                                fontSize: "0.68rem",
                                                fontWeight: 700,
                                            }}
                                        >
                                            {emails.length}
                                        </Box>
                                    )}
                                    <KeyboardArrowDownOutlined
                                        sx={{
                                            fontSize: "1.15rem",
                                            color: mTokens.textSecondary,
                                            transform: open ? "rotate(180deg)" : "none",
                                            transition: "transform 0.18s ease",
                                        }}
                                    />
                                </Box>
                            </Box>

                            <Popover
                                open={open}
                                anchorEl={anchorEl}
                                onClose={() => { setAnchorEl(null); commitDraft(); }}
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                transformOrigin={{ vertical: "top", horizontal: "left" }}
                                PaperProps={{
                                    sx: {
                                        width: 340,
                                        maxWidth: "90vw",
                                        mt: 0.5,
                                        borderRadius: "12px",
                                        border: `1px solid ${mTokens.border}`,
                                        backgroundColor: mTokens.bg,
                                        backgroundImage: "none",
                                        p: 1.5,
                                        boxShadow: isDark ? "0 16px 40px rgba(0,0,0,0.45)" : "0 16px 40px rgba(15,23,42,0.12)",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 0.6,
                                        maxHeight: 200,
                                        overflowY: "auto",
                                        mb: 1,
                                        pr: 0.5,
                                    }}
                                >
                                    {emails.length === 0 && (
                                        <Typography sx={{ fontSize: "0.8rem", color: mTokens.textSecondary }}>
                                            No emails yet — add one below.
                                        </Typography>
                                    )}
                                    {emails.map((email) => (
                                        <Chip
                                            key={email}
                                            label={email}
                                            onDelete={() => removeEmail(email)}
                                            sx={{
                                                height: "24px",
                                                borderRadius: "999px",
                                                backgroundColor: isDark ? "rgba(20,184,166,0.16)" : "rgba(13,148,136,0.12)",
                                                color: `${mTokens.accent} !important`,
                                                border: `1px solid ${isDark ? "rgba(20,184,166,0.26)" : "rgba(13,148,136,0.25)"}`,
                                                fontWeight: 600,
                                                fontSize: "0.72rem",
                                                "& .MuiChip-deleteIcon": {
                                                    color: isDark ? "rgba(20,184,166,0.6)" : "rgba(13,148,136,0.55)",
                                                    fontSize: "16px",
                                                    "&:hover": { color: isDark ? "rgba(20,184,166,0.95)" : "rgba(13,148,136,0.9)" },
                                                },
                                            }}
                                        />
                                    ))}
                                </Box>
                                <TextField
                                    autoFocus
                                    fullWidth
                                    size="small"
                                    placeholder="Add email and press Enter"
                                    value={draft}
                                    onChange={(e) => setDraft(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === ",") {
                                            e.preventDefault();
                                            commitDraft();
                                        }
                                    }}
                                    onBlur={commitDraft}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: `${mTokens.inputBg} !important`,
                                            borderRadius: "8px !important",
                                            fontSize: "0.85rem",
                                        },
                                        "& fieldset": { borderColor: `${mTokens.inputBorder} !important` },
                                        "&:hover fieldset": { borderColor: `${mTokens.accent} !important` },
                                        "& .Mui-focused fieldset": { borderColor: `${mTokens.accent} !important` },
                                    }}
                                />
                            </Popover>
                        </>
                    );
                }}
            />
        );
    };
    const { ManufacturerData } = useManufacturerListSlice();
    const { allCodeTablesValuesMap } = useCodetablesSlice();
    const { manufacturerTemplatesData } = usePracticeEditSlice();
    const [showTemplatePopup, setShowTemplatePopup] = React.useState(false);
    const [showOptionsPopup, setShowOptionsPopup] = useState<OptionPopupObjectProps>({ message: "", show: false });
    const [templateEditData, setTemplateEditData] = useState<any>(undefined);
    const [isTemplateEditMode, setIsTemplateEditMode] = useState(false);
    const isDownloading = useRef(false);
    const cardSx = {
        borderRadius: "16px",
        border: `1px solid ${mTokens.border}`,
        backgroundColor: mTokens.bg,
        backgroundImage: "none",
        overflow: "hidden" as const,
        boxShadow: isDark ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
    };

    //CS-1518 START
    const templateLevel = watch("customConfig.template_level");
    const isPharmacyEnabled = watch("isPharmacy");
    const pharmacyBillToDisplay = watch("pharmacyBillToDisplay") || [];
    const agreementGroupingEnabled = watch("agreementGrouping");
    const manufacturerHasLiveServiceAgreement = ManufacturerData?.liveServiceAgreementPresent === true;

    const showAgreementGroupingLiveDocumentError =
        !!agreementGroupingEnabled && ManufacturerData?.liveServiceAgreementPresent === false;

    const rejectAgreementGroupingWithoutLiveDocument = () => {
        const alertObj: SingleAlertInfo = {
            message: MSG_NO_LIVE_SERVICE_AGREEMENT_FOR_MANUFACTURER,
            alertType: "error",
        };
        dispatch(setSingleAlertObj(alertObj));
    };
    const billToFieldsDisabled = !isPharmacyEnabled;
    const billToControlsSxWhenDisabled = useMemo(
        () =>
            billToFieldsDisabled
                ? {
                      "& .MuiCheckbox-root.Mui-disabled, & .MuiRadio-root.Mui-disabled": {
                          color: `${mTokens.textSecondary} !important`,
                          opacity: 0.45,
                      },
                      "& .MuiCheckbox-root.Mui-disabled.Mui-checked, & .MuiRadio-root.Mui-disabled.Mui-checked": {
                          color: `${mTokens.textSecondary} !important`,
                          opacity: 0.45,
                      },
                  }
                : {},
        [billToFieldsDisabled, mTokens.textSecondary]
    );
    useEffect(() => {
        if (!isPharmacyEnabled) {
            clearErrors(["pharmacyBillToDisplay", "pharmacyBillToDefault"]);
        }
    }, [isPharmacyEnabled, clearErrors]);
    const [previousTemplateLevel, setPreviousTemplateLevel] = useState<string | null>(null);
    const [showTemplateLevelWarning, setShowTemplateLevelWarning] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    //CS-1563 START
    const canEditStripeConfig = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessStripeConfig", CAN_ACCESS_STRIPE_CONFIG.EDIT)(state));
    const canAddStripeConfig = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessStripeConfig", CAN_ACCESS_STRIPE_CONFIG.ADD)(state));
    const canViewStripeConfig = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessStripeConfig", CAN_ACCESS_STRIPE_CONFIG.VIEW)(state));
    const canAccessStripeConfig = canEditStripeConfig || (canAddStripeConfig && !isEditing) || canViewStripeConfig;

    // Determine if stripe config should be read-only
    const isStripeConfigReadOnly = canViewStripeConfig && !canEditStripeConfig && !canAddStripeConfig;

    // Watch stripe integration toggle to control other fields
    const stripeIntegrationEnabled = watch("stripeConfig.stripe_integration");
    const paymentFeeApplicable = watch("stripeConfig.platform_fee_applicable");

    // Trigger form re-validation when stripe integration state changes
    useEffect(() => {
        // Re-validate the stripe-related fields when integration is toggled
        // This ensures validation errors are immediately shown/hidden
        trigger(['stripeConfig.connected_account_id', 'stripeConfig.payment_method']);
    }, [stripeIntegrationEnabled, trigger]);

    const canAddNetsuiteConfig = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessNetsuiteConfig", CAN_ACCESS_NETSUITE_CONFIG.ADD)(state));
    const canEditNetsuiteConfig = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessNetsuiteConfig", CAN_ACCESS_NETSUITE_CONFIG.EDIT)(state));
    const canViewNetsuiteConfig = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessNetsuiteConfig", CAN_ACCESS_NETSUITE_CONFIG.VIEW)(state));

    const canAccessNetsuiteConfig = canEditNetsuiteConfig || (canAddNetsuiteConfig && !isEditing) ||canViewNetsuiteConfig;
    const isNetsuiteConfigReadOnly = canViewNetsuiteConfig && !canEditNetsuiteConfig && !canAddNetsuiteConfig;

    const isTokenValueAvailable = useToken();
    const canAccessPharmacyConfig = !!isTokenValueAvailable(CAN_ACCESS_APPLICATION.MANUFACTURER_MANAGEMENT);

    const safeNumericConversion = (value: any): string => {
        if (value === null || value === undefined || value === '') return '';

        // Remove commas from formatted numbers
        const cleanValue = typeof value === 'string' ? value.replace(/,/g, '') : value;
        const numValue = parseFloat(cleanValue);
        if (isNaN(numValue)) return '';

        return numValue.toString();
    };


    // Helper function to convert form data to backend format
    const convertFormToBackendData = (formStripeConfig: any) => {
        if (!formStripeConfig) return {};

        return {
            stripe_integration: formStripeConfig.stripe_integration ? "Y" : "N",
            connected_account_id: formStripeConfig.connected_account_id || '',
            payment_method: Array.isArray(formStripeConfig.payment_method)
                ? formStripeConfig.payment_method.join(',')
                : formStripeConfig.payment_method || '',
            platform_fee_applicable: formStripeConfig.platform_fee_applicable ? "Y" : "N",
            platform_fee_card_percent: safeNumericConversion(formStripeConfig.platform_fee_card_percent),
            platform_fee_card_additional: safeNumericConversion(formStripeConfig.platform_fee_card_additional),
            platform_fee_us_bank_account_percent: safeNumericConversion(formStripeConfig.platform_fee_us_bank_account_percent),
            platform_fee_us_bank_account_max_charge: safeNumericConversion(formStripeConfig.platform_fee_us_bank_account_max_charge),
        };
    };
    //CS-1563 END

    const templateColumns = [
        { id: "type", label: "Type" },
        { id: "templateName", label: "Template Name", minWidth: 120 },
        { id: "description", label: "Description", minWidth: 120 },
        { id: "templateLevel", label: "Template Level", minWidth: 120 },
        { id: "inUse", label: "In Use", minWidth: 120 },
        { id: "inactiveDate", label: "Inactive Date" },
        { id: "action", label: "Actions" },
    ];

    const templateIconDetails = [
        { icon: <Edit color="info" />, text: "Edit" },
        { icon: <DoDisturbAltOutlined color="warning" />, text: "Inactivate" },
        { icon: <DownloadOutlined color="success" />, text: "Download" },
    ];

    const manufacturerTemplateRows = useMemo(() => {
        if (!manufacturerTemplatesData) return [];

        return manufacturerTemplatesData.map(template => ({
            type: template.type,
            templateName: template.fileName || `Template ${template.templateId}`,
            description: template.description || 'N/A',
            templateLevel: template.templateLevel || 'N/A',
            inUse: template.inactiveDate ? 'No' : 'Yes',
            inactiveDate: template.inactiveDate || '',
            templateId: template.templateId,
            manufacturerPracticeTemplateId: template.manufacturerPracticeTemplateId,
        }));
    }, [manufacturerTemplatesData]);

    useEffect(() => {
        setIsMounted(true);
        //CS-1672 - Removed fetchAppConfigList() call as we now use code table data
    }, []);

    useEffect(() => {
        if (!isMounted || !isEditing || !templateLevel) {
            return;
        }

        if (!isInitialized) {
            setPreviousTemplateLevel(templateLevel);
            setIsInitialized(true);
        } else if (previousTemplateLevel && templateLevel !== previousTemplateLevel) {
            const activeTemplates = manufacturerTemplatesData?.filter(template => !template.inactiveDate);

            if (activeTemplates && activeTemplates.length > 0 && templateLevel !== "Manufacturer") {
                setShowTemplateLevelWarning(true);
            } else {
                setPreviousTemplateLevel(templateLevel);
            }
        }
    }, [templateLevel, previousTemplateLevel, manufacturerTemplatesData, isEditing, isInitialized, isMounted]);

    const handleTemplateLevelChange = async () => {
        const activeTemplates = manufacturerTemplatesData?.filter(template => !template.inactiveDate);

        if (activeTemplates && activeTemplates.length > 0) {
            try {
                for (const template of activeTemplates) {
                    await dispatch(inactivateManufacturerTemplateData(template.manufacturerPracticeTemplateId));
                }

                const successObj: SingleAlertInfo = {
                    message: `Template level changed successfully. ${activeTemplates.length} active template(s) have been inactivated.`,
                    alertType: "success",
                };
                dispatch(setSingleAlertObj(successObj));

                if (ManufacturerData?.manufacturerId) {
                    dispatch(fetchManufacturerTemplatesData(ManufacturerData.manufacturerId.toString()));
                }

                setPreviousTemplateLevel(templateLevel);
            } catch (error) {
                const errorObj: SingleAlertInfo = {
                    message: "Failed to inactivate existing templates. Please try again.",
                    alertType: "error",
                };
                dispatch(setSingleAlertObj(errorObj));
            }
        }

        setShowTemplateLevelWarning(false);
    };

    const cancelTemplateLevelChange = () => {
        setValue("customConfig.template_level", previousTemplateLevel);
        setShowTemplateLevelWarning(false);
    };
    //CS-1518 END

    useEffect(() => {
        if (location.state?.mfrData?.manufacturerId) {
            dispatch(fetchManufacturerDataById(parseInt(location.state?.mfrData?.manufacturerId)));
            //CS-1518
            dispatch(fetchManufacturerTemplatesData(location.state.mfrData.manufacturerId.toString()));
            setIsInitialized(false);
            setPreviousTemplateLevel(null);
            setShowTemplateLevelWarning(false); 
            setIsMounted(false); 
            setTimeout(() => setIsMounted(true), 100);
        }
        //CS-1518
        if (!allCodeTablesValuesMap) {
            dispatch(fetchAllCodeTablesValues());
        }
    }, [dispatch, location.state?.mfrData?.manufacturerId, allCodeTablesValuesMap])

    const invoiceDueDateOptions = useMemo(() => {
        let statuses: CodeTable[] = [];
        if (allCodeTablesValuesMap) {
            statuses = getCodeTableValuesByTableName(allCodeTablesValuesMap, INVOICE_DUE_DATE);
        }
        if (!statuses || statuses.length === 0) {
            dispatch(fetchAllCodeTablesValues());
        }
        let options: { label: string, value: any }[] = [];
        statuses?.map((option) => {
            options.push({ label: option.displayValue, value: option.displayValue });
        });
        return options;
    }, [allCodeTablesValuesMap]);

    const invoiceDueDaysOptions = useMemo(() => {
        let statuses: CodeTable[] = [];
        if (allCodeTablesValuesMap) {
            statuses = getCodeTableValuesByTableName(allCodeTablesValuesMap, INVOICE_DUE_DAYS);
        }
        if (!statuses || statuses.length === 0) {
            dispatch(fetchAllCodeTablesValues());
        }
        let options: { label: string, value: any }[] = [];
        statuses?.map((option) => {
            options.push({ label: option.displayValue, value: option.displayValue });
        });
        return options;
    }, [allCodeTablesValuesMap]);

    //CS-1518 START
    const templateLevelOptions = useMemo(() => {
        let statuses: CodeTable[] = [];
        if (allCodeTablesValuesMap) {
            statuses = getCodeTableValuesByTableName(allCodeTablesValuesMap, TEMPLATE_LEVELS);
        }
        if (!statuses || statuses.length === 0) {
            dispatch(fetchAllCodeTablesValues());
        }
        let options: { label: string, value: any }[] = [];
        statuses?.map((option) => {
            options.push({ label: option.displayValue, value: option.displayValue });
        });
        return options;
    }, [allCodeTablesValuesMap]);
    //CS-1518 END

    //CS-1563 START
    const paymentMethodsOptions = useMemo(() => {
        let statuses: CodeTable[] = [];
        if (allCodeTablesValuesMap) {
            statuses = getCodeTableValuesByTableName(allCodeTablesValuesMap, "PaymentMethods");
        }
        if (!statuses || statuses.length === 0) {
            dispatch(fetchAllCodeTablesValues());
        }
        let options: { label: string, value: any }[] = [];
        statuses?.map((option) => {
            // Use keyName as value to match backend data format
            options.push({ label: option.displayValue, value: option.keyName });
        });

        return options;
    }, [allCodeTablesValuesMap]);

    const safeParseFloat = (value: any): number | null => {
        if (value === null || value === undefined || value === '') return null;

        // Remove commas from formatted numbers
        const cleanValue = typeof value === 'string' ? value.replace(/,/g, '') : value;
        const parsed = parseFloat(cleanValue.toString());
        return isNaN(parsed) ? null : parsed;
    };

    // Helper function to convert backend data to form data
    const convertBackendToFormData = useCallback((backendStripeConfig: any) => {
        if (!backendStripeConfig) {
            return {
                stripe_integration: false,
                connected_account_id: '',
                payment_method: [],
                platform_fee_applicable: false,
                platform_fee_card_percent: null,
                platform_fee_card_additional: null,
                platform_fee_us_bank_account_percent: null,
                platform_fee_us_bank_account_max_charge: null,
            };
        }

        let paymentMethodArray: string[] = [];
        if (backendStripeConfig.payment_method) {
            const backendMethods = backendStripeConfig.payment_method.split(',').map((method: string) => method.trim());

            // Map backend values to form values using available options
            paymentMethodArray = backendMethods.filter((method: string) => {
                // Check if the method exists in our options (either as keyName or displayValue)
                return paymentMethodsOptions.some(option =>
                    option.value === method || option.label === method
                );
            });

            // If no matches found, try to use the backend values directly
            if (paymentMethodArray.length === 0) {
                paymentMethodArray = backendMethods;
            }
        }

        // Helper function to safely parse numeric values from backend


        return {
            stripe_integration: backendStripeConfig.stripe_integration === "Y",
            connected_account_id: backendStripeConfig.connected_account_id || '',
            payment_method: paymentMethodArray,
            platform_fee_applicable: backendStripeConfig.platform_fee_applicable === "Y",
            platform_fee_card_percent: safeParseFloat(backendStripeConfig.platform_fee_card_percent),
            platform_fee_card_additional: safeParseFloat(backendStripeConfig.platform_fee_card_additional),
            platform_fee_us_bank_account_percent: safeParseFloat(backendStripeConfig.platform_fee_us_bank_account_percent),
            platform_fee_us_bank_account_max_charge: safeParseFloat(backendStripeConfig.platform_fee_us_bank_account_max_charge),
        };
    }, [paymentMethodsOptions]);


    const convertNetsuiteBackendToFormData = useCallback((backendNetsuiteConfig: any) => {
        if (!backendNetsuiteConfig) {
            return {
                netsuite_integration: false,
                connected_customer_id: null,
                consumer_key: null,
                consumer_secret: null,
                access_token: null,
                token_secret: null,
                realm: null,
                post_sales_order_api_url: null
            };
        }

        return {
            netsuite_integration: backendNetsuiteConfig.netsuite_integration === "Y",
            connected_customer_id: safeParseFloat(backendNetsuiteConfig.connected_customer_id),
            consumer_key: backendNetsuiteConfig.consumer_key || '',
            consumer_secret: backendNetsuiteConfig.consumer_secret || '',
            access_token: backendNetsuiteConfig.access_token || '',
            token_secret: backendNetsuiteConfig.token_secret || '',
            realm: backendNetsuiteConfig.realm || '',
            post_sales_order_api_url: backendNetsuiteConfig.post_sales_order_api_url || ''
        };
    }, []);

    const onSubmit = async (data: any) => {

        // Debug: Show how comma-formatted values are processed
        if (data.stripeConfig) {
            if (data.stripeConfig.platform_fee_card_percent) {
                const cleanValue = typeof data.stripeConfig.platform_fee_card_percent === 'string'
                    ? data.stripeConfig.platform_fee_card_percent.replace(/,/g, '')
                    : data.stripeConfig.platform_fee_card_percent;
            }
            if (data.stripeConfig.platform_fee_us_bank_account_percent) {
                const cleanValue = typeof data.stripeConfig.platform_fee_us_bank_account_percent === 'string'
                    ? data.stripeConfig.platform_fee_us_bank_account_percent.replace(/,/g, '')
                    : data.stripeConfig.platform_fee_us_bank_account_percent;
            }
        }
        //CS-1563 END

        if (isEditing) {
            await handleEditManufacturer({ ...data, mfrId: location.state?.mfrData?.manufacturerId });
        } else {
            await handleSaveManufacturer({ ...data });
        }
    };

    const onClose = () => {
        navigate(-1);
    }

    const convertNetsuiteConfig = (netsuiteConfig: any) => {
        if (!netsuiteConfig) return {};

        return {
            netsuite_integration: netsuiteConfig.netsuite_integration ? "Y" : "N",
            connected_customer_id: safeNumericConversion(netsuiteConfig.connected_customer_id),
            consumer_key: netsuiteConfig.consumer_key || '',
            consumer_secret: netsuiteConfig.consumer_secret || '',
            access_token: netsuiteConfig.access_token || '',
            token_secret: netsuiteConfig.token_secret || '',
            realm: netsuiteConfig.realm || '',
            post_sales_order_api_url: netsuiteConfig.post_sales_order_api_url || ''
        };
    };

    const handleSaveManufacturer = async (data: any) => {
        let errorObj: MainErrorInfo = {
            title: "",
        };
        if (data?.agreementGrouping && !manufacturerHasLiveServiceAgreement) {
            rejectAgreementGroupingWithoutLiveDocument();
            return;
        }
        const convertedStripeConfig = convertFormToBackendData(data?.stripeConfig);//CS-1563
        const covertedNetsuiteConfig = convertNetsuiteConfig(data?.netsuiteConfig);
        const updatedData = {
            ...data,
            inactiveDate: data?.inactiveDate ? moment(data?.inactiveDate.toString()).format("MM/DD/YYYY") : '',
            manufacturerName: data?.manufacturerName,
            customConfig: JSON.stringify(data?.customConfig),
            contactPhone: data?.contactPhone,
            notificationEmail: JSON.stringify(data?.notificationEmail),
            stripeConfig: JSON.stringify(convertedStripeConfig),
            netsuiteConfig: JSON.stringify(covertedNetsuiteConfig),
            isPharmacy: !!data?.isPharmacy,
            agreementGrouping: data?.isPharmacy && data?.agreementGrouping ? "Y" : "N",
            miscConfig: toPharmacyConfig(
                !!data?.isPharmacy,
                data?.pharmacyBillToDisplay,
                data?.pharmacyBillToDefault
            ),
        }
        delete (updatedData as any).pharmacyBillToDisplay;
        delete (updatedData as any).pharmacyBillToDefault;

        try {
            const response = await dispatch(saveManufacturers(updatedData));
            if (response.payload && response.payload.message === 'SUCCESS') {

                let alertMessage = isEditing ?
                    "Manufacturer Updated Successfully!" :
                    "Manufacturer Created Successfully!";

                const alertObj: SingleAlertInfo = {
                    message: alertMessage,
                    alertType: "success",
                };

                await dispatch(setSingleAlertObj(alertObj));
                navigate(-1);

            } else {
                let errorSentence = '';
                if (response.payload.errors.length <= 0) {
                    errorSentence = response.payload.message || "An unknown error occurred.";
                }
                errorObj.title = "Manufacturer Creation Failed!";
                errorObj.errorMessageStream = errorSentence;
                dispatch(setMainErrorObj(errorObj));
            }
        } catch (error) {
            errorObj.title = "Error creating Manufacturer";
            errorObj.errorMessageStream = "" + error;
            dispatch(setMainErrorObj(errorObj));
        }
    };

    const handleEditManufacturer = async (data: any) => {
        let errorObj: MainErrorInfo = {
            title: "",
        };
        if (data?.agreementGrouping && !manufacturerHasLiveServiceAgreement) {
            rejectAgreementGroupingWithoutLiveDocument();
            return;
        }
        const convertedStripeConfig = convertFormToBackendData(data?.stripeConfig);
        const covertedNetsuiteConfig = convertNetsuiteConfig(data?.netsuiteConfig);

        const updatedData = {
            ...data,
            inactiveDate: data?.inactiveDate ? moment(data?.inactiveDate.toString()).format("MM/DD/YYYY") : '',
            manufacturerId: data?.manufacturerId,
            manufacturerName: data?.manufacturerName,
            customConfig: JSON.stringify(data?.customConfig),
            contactPhone: data?.contactPhone,
            notificationEmail: JSON.stringify(data?.notificationEmail),
            stripeConfig: JSON.stringify(convertedStripeConfig),
            netsuiteConfig: JSON.stringify(covertedNetsuiteConfig),
            isPharmacy: !!data?.isPharmacy,
            agreementGrouping: data?.isPharmacy && data?.agreementGrouping ? "Y" : "N",
            miscConfig: toPharmacyConfig(
                !!data?.isPharmacy,
                data?.pharmacyBillToDisplay,
                data?.pharmacyBillToDefault
            ),
        }
        delete (updatedData as any).pharmacyBillToDisplay;
        delete (updatedData as any).pharmacyBillToDefault;

        try {
            const response = await dispatch(editManufacturerData(updatedData));
            if (response.payload && response.payload.message === 'SUCCESS') {

                let alertMessage =
                    "Manufacturer Updated Successfully!"

                const alertObj: SingleAlertInfo = {
                    message: alertMessage,
                    alertType: "success",
                };

                await dispatch(setSingleAlertObj(alertObj));
                navigate(-1);

            } else {
                let errorSentence = '';
                if (response.payload.errors.length <= 0) {
                    errorSentence = response.payload.message || "An unknown error occurred.";
                } 

                errorObj.title = "Manufacturer Updation Failed!";
                errorObj.errorMessageStream = errorSentence;
                dispatch(setMainErrorObj(errorObj));
            }
        } catch (error) {
            errorObj.title = "Error Updating Manufacturer";
            errorObj.errorMessageStream = "" + error;
            dispatch(setMainErrorObj(errorObj));
        }
    };
    const defaultValues = useCallback(() => {
        if (ManufacturerData && isEditing) {
            //CS-1563 START
            const formData = { ...ManufacturerData };

            // Handle stripe config conversion if it exists
            let stripeConfig = null;
            try {
                if (ManufacturerData.stripeConfig) {
                    // Parse if it's a string, otherwise use as is
                    if (typeof ManufacturerData.stripeConfig === 'string') {
                        const configStr = ManufacturerData.stripeConfig as string;
                        // Handle empty string or "{}" cases
                        if (configStr.trim() === '' || configStr.trim() === '{}') {
                            stripeConfig = null;
                        } else {
                            stripeConfig = JSON.parse(configStr);
                        }
                    } else if (typeof ManufacturerData.stripeConfig === 'object' && ManufacturerData.stripeConfig !== null) {
                        // Handle empty object case
                        if (Object.keys(ManufacturerData.stripeConfig).length === 0) {
                            stripeConfig = null;
                        } else {
                            stripeConfig = ManufacturerData.stripeConfig;
                        }
                    }
                }

                formData.stripeConfig = convertBackendToFormData(stripeConfig);
            } catch (error) {
                formData.stripeConfig = convertBackendToFormData(null);
            }

            let netsuiteConfig = null;
            try {
                if (ManufacturerData.netsuiteConfig) {
                    if (typeof ManufacturerData.netsuiteConfig === 'string') {
                        const configStr = ManufacturerData.netsuiteConfig as string;
                        if (configStr.trim() === '' || configStr.trim() === '{}') {
                            netsuiteConfig = null;
                        } else {
                            netsuiteConfig = JSON.parse(configStr);
                        }
                    } else if (typeof ManufacturerData.netsuiteConfig === 'object' && ManufacturerData.netsuiteConfig !== null) {
                        if (Object.keys(ManufacturerData.netsuiteConfig).length === 0) {
                            netsuiteConfig = null;
                        } else {
                            netsuiteConfig = ManufacturerData.netsuiteConfig;
                        }
                    }
                }

                formData.netsuiteConfig = convertNetsuiteBackendToFormData(netsuiteConfig);
            } catch (error) {
                formData.netsuiteConfig = convertNetsuiteBackendToFormData(netsuiteConfig);
            }

            //CS-1627 START
            // Ensure customConfig is an object and merge with defaults for any missing fields
            const defaultCustomConfig = {
                cc_authorized_practice_user: 'N',
                provider_signature_required: 'N',
                template_level: 'Default'
            };

            let parsedCustomConfig: any = {};
            try {
                if (formData.customConfig) {
                    if (typeof formData.customConfig === 'string') {
                        const cfgStr = formData.customConfig as string;
                        if (cfgStr.trim() === '' || cfgStr.trim() === '{}' ) {
                            parsedCustomConfig = {};
                        } else {
                            parsedCustomConfig = JSON.parse(cfgStr);
                        }
                    } else if (typeof formData.customConfig === 'object' && formData.customConfig !== null) {
                        parsedCustomConfig = formData.customConfig;
                    }
                }
            } catch (err) {
                parsedCustomConfig = {};
            }

            formData.customConfig = {
                ...defaultCustomConfig,
                ...parsedCustomConfig
            };

            // Ensure notificationEmail is an object (form expects nested fields)
            try {
                if (formData.notificationEmail) {
                    if (typeof formData.notificationEmail === 'string') {
                        const neStr = formData.notificationEmail as string;
                        if (neStr.trim() === '' || neStr.trim() === '{}' ) {
                            formData.notificationEmail = {
                                ivr_info: [],
                                order_info: [],
                                return_info: [],
                                tissue_info: [],
                                product_agreement_info: []
                            };
                        } else {
                            formData.notificationEmail = JSON.parse(neStr);
                        }
                    }
                } else {
                    formData.notificationEmail = {
                        ivr_info: [],
                        order_info: [],
                        return_info: [],
                        tissue_info: [],
                        product_agreement_info: []
                    };
                }
            } catch (err) {
                formData.notificationEmail = {
                    ivr_info: [],
                    order_info: [],
                    return_info: [],
                    tissue_info: [],
                    product_agreement_info: []
                };
            }
            //CS-1627 END

            // Pharmacy toggle is driven by isPharmacy from the getManufacturer response.
            formData.isPharmacy = toBooleanFlag(ManufacturerData?.isPharmacy);
            formData.agreementGrouping = toBooleanFlag(ManufacturerData?.agreementGrouping);
            const pharmacyBillTo = pharmacyBillToFromConfig(ManufacturerData?.miscConfig);
            formData.pharmacyBillToDisplay = pharmacyBillTo.enabledValues;
            formData.pharmacyBillToDefault = pharmacyBillTo.defaultValue;

            reset(formData);
        } else {
            // Set default values for new manufacturer
            reset({
                //CS-1627
                customConfig: {
                    cc_authorized_practice_user: 'N',
                    provider_signature_required: 'N',
                    template_level: 'Default'
                },
                //
                stripeConfig: {
                    stripe_integration: false,
                    connected_account_id: '',
                    payment_method: [], // array for form
                    platform_fee_applicable: false,
                    platform_fee_card_percent: null,
                    platform_fee_card_additional: null,
                    platform_fee_us_bank_account_percent: null,
                    platform_fee_us_bank_account_max_charge: null,
                },
                netsuiteConfig: {
                    netsuite_integration: false,
                    connected_customer_id: null,
                    consumer_key: null,
                    consumer_secret: null,
                    access_token: null,
                    token_secret: null,
                    realm: null,
                    post_sales_order_api_url: null
                },
                isPharmacy: false,
                agreementGrouping: false,
                pharmacyBillToDisplay: [],
                pharmacyBillToDefault: ""
            });
        }
    }, [ManufacturerData, reset, convertBackendToFormData]);
    //CS-1563 END

    useEffect(() => {
        defaultValues();
    }, [defaultValues]);

    //CS-1563 START
    useEffect(() => {
        const manufacturerId = location.state?.mfrData?.manufacturerId;

        // Force reset the form when switching manufacturers
        if (manufacturerId) {
            // Clear the form first to prevent stale data
            reset({
                stripeConfig: {
                    stripe_integration: false,
                    connected_account_id: '',
                    payment_method: [],
                    platform_fee_applicable: false,
                    platform_fee_card_percent: null,
                    platform_fee_card_additional: null,
                    platform_fee_us_bank_account_percent: null,
                    platform_fee_us_bank_account_max_charge: null,
                },
                netsuiteConfig: {
                    netsuite_integration: false,
                    connected_customer_id: null,
                    consumer_key: null,
                    consumer_secret: null,
                    access_token: null,
                    token_secret: null,
                    realm: null,
                    post_sales_order_api_url: null
                },
                isPharmacy: false,
                agreementGrouping: false,
                pharmacyBillToDisplay: [],
                pharmacyBillToDefault: ""
            });
        }
    }, [location.state?.mfrData?.manufacturerId, reset]);

    // Cleanup effect to reset form when component unmounts
    useEffect(() => {
        return () => {
            // Reset form on unmount to prevent data persistence
            reset({
                stripeConfig: {
                    stripe_integration: false,
                    connected_account_id: '',
                    payment_method: [],
                    platform_fee_applicable: false,
                    platform_fee_card_percent: null,
                    platform_fee_card_additional: null,
                    platform_fee_us_bank_account_percent: null,
                    platform_fee_us_bank_account_max_charge: null,
                },
                netsuiteConfig: {
                    netsuite_integration: false,
                    connected_customer_id: null,
                    consumer_key: null,
                    consumer_secret: null,
                    access_token: null,
                    token_secret: null,
                    realm: null,
                    post_sales_order_api_url: null
                },
                isPharmacy: false,
                agreementGrouping: false,
                pharmacyBillToDisplay: [],
                pharmacyBillToDefault: ""
            });
        };
    }, [reset]);
    //CS-1563 END

    // Handle initialization when ManufacturerData is loaded
    useEffect(() => {
        if (ManufacturerData && isEditing && !isInitialized) {
            //CS-1627 START
            // Safely parse customConfig (it may be a string) and initialize template level
            let templateLevelFromData: string | null = null;
            try {
                if (ManufacturerData.customConfig) {
                    if (typeof ManufacturerData.customConfig === 'string') {
                        const cfgStr = (ManufacturerData.customConfig as string).trim();
                        if (cfgStr !== '' && cfgStr !== '{}') {
                            const parsed = JSON.parse(cfgStr);
                            templateLevelFromData = parsed?.template_level || null;
                        }
                    } else if (typeof ManufacturerData.customConfig === 'object' && ManufacturerData.customConfig !== null) {
                        templateLevelFromData = ManufacturerData.customConfig.template_level || null;
                    }
                }
            } catch (err) {
                templateLevelFromData = null;
            }

            if (templateLevelFromData) {
                setPreviousTemplateLevel(templateLevelFromData);
                setIsInitialized(true);
            }
            //CS-1627 END
        }
    }, [ManufacturerData, isEditing, isInitialized]);

    //CS-1518 START
    const clickShowTemplatePopup = () => {
        setIsTemplateEditMode(false);
        setTemplateEditData(undefined);
        setShowTemplatePopup(true);
    };

    const clickCloseTemplatePopup = () => {
        setShowTemplatePopup(false);
        setIsTemplateEditMode(false);
        setTemplateEditData(undefined);
    };

    const addManufacturerTemplate = async () => {
        if (ManufacturerData?.manufacturerId) {
            dispatch(fetchManufacturerTemplatesData(ManufacturerData.manufacturerId.toString()));
        }
    };

    const handleEditManufacturerTemplate = (row: any) => {
        const templateData = manufacturerTemplatesData?.find(template => template.manufacturerPracticeTemplateId === row.manufacturerPracticeTemplateId);

        if (templateData) {
            const editData = {
                manufacturerPracticeTemplateId: templateData.manufacturerPracticeTemplateId,
                templateType: templateData.type || "",
                templateId: templateData.templateId?.toString() || ""
            };

            setTemplateEditData(editData);
            setIsTemplateEditMode(true);
            setShowTemplatePopup(true);
        }
    };

    const handleInactivateManufacturerTemplate = (row: any) => {
        setShowOptionsPopup({
            message: `Are you sure you want to inactivate this manufacturer template?`,
            show: true,
            variant: "warning",
            buttons: [
                {
                    name: "Yes",
                    color: 'primary',
                    onClick: async () => {
                        try {
                            const result = await dispatch(inactivateManufacturerTemplateData(row.manufacturerPracticeTemplateId));
                            if (inactivateManufacturerTemplateData.fulfilled.match(result)) {
                                const successObj: SingleAlertInfo = {
                                    message: "Manufacturer Template Successfully Inactivated",
                                    alertType: "success",
                                };
                                dispatch(setSingleAlertObj(successObj));
                                // Refresh the manufacturer templates list
                                if (ManufacturerData?.manufacturerId) {
                                    dispatch(fetchManufacturerTemplatesData(ManufacturerData.manufacturerId.toString()));
                                }
                            } else {
                                const errorObj: SingleAlertInfo = {
                                    message: "Failed to inactivate manufacturer template. Please try again.",
                                    alertType: "error",
                                };
                                dispatch(setSingleAlertObj(errorObj));
                            }
                        } catch (error) {
                            const errorObj: SingleAlertInfo = {
                                message: "An error occurred while inactivating the manufacturer template.",
                                alertType: "error",
                            };
                            dispatch(setSingleAlertObj(errorObj));
                        }
                        setShowOptionsPopup({ message: "", show: false });
                    }
                },
                {
                    name: "No",
                    color: 'error',
                    onClick: () => {
                        setShowOptionsPopup({ message: "", show: false });
                    }
                }
            ]
        });
    };

    const handleManufacturerTemplateDownload = async (templateId: string) => {
        if (isDownloading.current) return;
        isDownloading.current = true;

        try {
            const actionResult = await dispatch(fetchTemplateById(templateId));
            const documentData = actionResult.payload;
            if (documentData && documentData.content) {
                downloadBase64File(documentData.content, documentData.templateFileName, 'image/jpeg');
            }
        } finally {
            isDownloading.current = false;
        }
    };

    const manufacturerTemplateActionComponent = (row: any): JSX.Element => {
        const isInactive = row.inactiveDate && row.inactiveDate.trim() !== "";

        return (
            <Box sx={{ display: 'flex', gap: 1 }}>
                {!isInactive && (
                    <CustomIconButton
                        color="info"
                        size="small"
                        variant="outlined"
                        tooltipMessage="Edit"
                        tooltipPlacement="top"
                        onClick={() => handleEditManufacturerTemplate(row)}
                    >
                        <Edit fontSize="small" />
                    </CustomIconButton>
                )}

                {!isInactive && (
                    <CustomIconButton
                        color="warning"
                        size="small"
                        variant="outlined"
                        tooltipMessage="Inactivate"
                        tooltipPlacement="top"
                        onClick={() => handleInactivateManufacturerTemplate(row)}
                    >
                        <DoDisturbAltOutlined fontSize="small" />
                    </CustomIconButton>
                )}

                <CustomIconButton
                    color="success"
                    size="small"
                    variant="outlined"
                    tooltipMessage="Download"
                    tooltipPlacement="top"
                    onClick={() => handleManufacturerTemplateDownload(row.templateId)}
                >
                    <DownloadOutlined fontSize="small" />
                </CustomIconButton>
            </Box>
        );
    };
    //CS-1518 END

    const showTemplatesTab = Boolean(isEditing && ManufacturerData?.manufacturerId && (templateLevel === "Manufacturer" || manufacturerTemplateRows?.length > 0));

    return (
        <Box sx={{
            margin: {
                xs: "20px 10px",
                sm: "20px",
            },
        }}>
            <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase", letterSpacing: "0.12em", mb: 0.3 }}>
                Manufacturers / {isEditing ? "Edit" : "Create"} Manufacturer
            </Typography>
            <Typography component="h1" sx={{ fontSize: "1.6rem", fontWeight: 800, color: mTokens.textPrimary, lineHeight: 1.1, mb: 2 }}>
                Manufacturer Management
            </Typography>
            <Box sx={cardSx} mb={5}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box sx={{ px: { xs: 1.5, sm: 2.5 }, py: 2.5, ...modernFormFieldsSx }}>
                    <Grid container spacing={2}>
                        <Grid item md={4} xs={12}>
                            <FieldLabel required>Manufacturer Name</FieldLabel>
                            <CustomTextField
                                control={control}
                                controllerName="manufacturerName"
                                label="Manufacturer Name"
                                size="small"
                                rules={{
                                    required: "Manufacturer Name is required.",
                                }}
                            />
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <FieldLabel required>Phone</FieldLabel>
                            <CustomPatternTextField
                                control={control}
                                name="contactPhone"
                                label="Phone"
                                size="small"
                                rules={{
                                    required: "Phone is required.",
                                    pattern: {
                                        value: /^(\+\d{1,2}\s)?\(\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                                        message: "Invalid phone number."
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item md={2.3} xs={12}>
                            <FieldLabel>V3 Pay Day</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="V3 Pay Day"
                                content="Enter the day of the month when payment is made to V3."
                                placement="left"
                            >
                                <CustomNumberField
                                    control={control}
                                    controllerName="v3PayDay"
                                    label="V3 Pay Day"
                                    size="small"
                                    allowDecimal={false}
                                    allowNegative={false}
                                    rules={{ min: { value: 1, message: "V3 pay day should be between 1 - 31" }, max: { value: 31, message: "V3 pay day should be between 1 - 31" } }}
                                />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={2.3} xs={12}>
                            <FieldLabel>V3 Pay Month</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="V3 Pay Month"
                                content="Enter the month when payment is made to V3."
                                placement="bottom-start"
                            >
                                <CustomNumberField
                                    control={control}
                                    controllerName="v3PayMonth"
                                    label="V3 Pay Month"
                                    size="small"
                                    allowDecimal={false}
                                    allowNegative={false}
                                    rules={{ min: { value: 1, message: "V3 pay month should be between 1 - 12" }, max: { value: 12, message: "V3 pay month should be between 1 - 12" } }}
                                />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={2.3} xs={12}>
                            <FieldLabel>Agency Pay Day</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Agency Pay Day"
                                content="Enter the day of the month when payment is made to the agency."
                                placement="bottom-start"
                            >
                                <CustomNumberField
                                    control={control}
                                    controllerName="agencyPayDay"
                                    label="Agency Pay Day"
                                    size="small"
                                    allowDecimal={false}
                                    allowNegative={false}
                                    rules={{ min: { value: 1, message: "Agency pay day should be between 1 - 31" }, max: { value: 31, message: "Agency pay day should be between 1 - 31" } }}
                                />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={2.3} xs={12}>
                            <FieldLabel>Agency Pay Month</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Agency Pay Month"
                                content="Enter the month when payment is made to the agency."
                                placement="bottom-start"
                            >
                                <CustomNumberField
                                    control={control}
                                    controllerName="agencyPayMonth"
                                    label="Agency Pay Month"
                                    size="small"
                                    allowDecimal={false}
                                    allowNegative={false}
                                    rules={{ min: { value: 1, message: "Agency pay month should be between 1 - 12" }, max: { value: 12, message: "Agency pay month should be between 1 - 12" } }}
                                />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={2.3} xs={12}>
                            <FieldLabel>Inactive Date</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Inactive Date"
                                content="Select an inactive date (from today onward) to deactivate the manufacturer."
                                placement="top-start"
                            >
                                <CustomDatePicker
                                    control={control}
                                    controllerName="inactiveDate"
                                    label="Inactive Date"
                                    size="small"
                                    isDisablePast={true}
                                    slotProps={datePickerSlotProps}
                                />
                            </FieldFocusPopup>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        <Grid item md={12} xs={12}>
                            <Box sx={{ mx: -2.8 }}>
                                <SectionHeader icon={<MailOutlined fontSize="small" />} title="Notification Emails" />
                            </Box>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <FieldLabel>IVR Info</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="IVR Notification Info"
                                content="Enter the email addresses to receive IVR notifications."
                                placement="left-start"
                            >
                                <EmailChipSummaryField control={control} controllerName="notificationEmail.ivr_info" />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <FieldLabel>Order Info</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Order Notification Info"
                                content="Enter the email addresses that should receive order related notifications."
                                placement="top-start"
                            >
                                <EmailChipSummaryField control={control} controllerName="notificationEmail.order_info" />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <FieldLabel>Return Info</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Return Notification Info"
                                content="Enter the email addresses that should receive return related notifications."
                                placement="top-start"
                            >
                                <EmailChipSummaryField control={control} controllerName="notificationEmail.return_info" />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <FieldLabel>Tissue Info</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Tissue Notification Info"
                                content="Enter the email addresses that should receive tissue related notifications."
                                placement="left-start"
                            >
                                <EmailChipSummaryField control={control} controllerName="notificationEmail.tissue_info" />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <FieldLabel>Product Agreement Info</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Product Agreement Notification Info"
                                content="Enter the email addresses that should receive product agreement related notifications."
                                placement="top-start"
                            >
                                <EmailChipSummaryField control={control} controllerName="notificationEmail.product_agreement_info" />
                            </FieldFocusPopup>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        <Grid item md={12} xs={12}>
                            <Box sx={{ mx: -2.8 }}>
                                <SectionHeader icon={<TuneOutlined fontSize="small" />} title="Custom Config" />
                            </Box>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <FieldLabel>Invoice Due By</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Invoice Due By"
                                content="Select the option used to determine the invoice due date."
                                placement="left-start"
                            >
                                <CustomDropdownField name="customConfig.invoice_due_date" label="Invoice Due By" size="small"
                                    options={invoiceDueDateOptions} control={control} />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <FieldLabel>Invoice Due Days</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Invoice Due Days"
                                content="Select the number of days until the invoice is due."
                                placement="top-start"
                            >
                                <CustomDropdownField name="customConfig.invoice_net_days" label="Invoice Due Days" size="small"
                                    options={invoiceDueDaysOptions} control={control} />
                            </FieldFocusPopup>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <FieldLabel>Send Emails to Authorized Practice Signer?</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Authorized Practice Signer Emails"
                                content="Select whether to send emails to the authorized practice signer."
                                placement="top-start"
                            >
                                <CustomDropdownField name="customConfig.cc_authorized_practice_user" label="Send Emails to Authorized Practice Signer?" size="small"
                                    options={[{ label: 'Yes', value: 'Y' }, { label: 'No', value: 'N' }]} control={control} />
                            </FieldFocusPopup>
                        </Grid>
                        {/* CS-1302 - Start */}
                        <Grid item md={4} xs={12}>
                            <FieldLabel>Provider Signature Required?</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Provider Signature"
                                content="Select whether the provider signature is required."
                                placement="left-start"
                            >
                                <CustomDropdownField name="customConfig.provider_signature_required" label="Provider Signature Required?" size="small"
                                    options={[{ label: 'Yes', value: 'Y' }, { label: 'No', value: 'N' }]} control={control} />
                            </FieldFocusPopup>
                        </Grid>
                        {/* CS-1302 - End */}
                        {/* CS-1518 START */}
                        <Grid item md={4} xs={12}>
                            <FieldLabel>Template Level</FieldLabel>
                            <FieldFocusPopup
                                enabled
                                title="Template Level"
                                content="Select the template level to be applied."
                                placement="bottom-start"
                            >
                                <CustomDropdownField name="customConfig.template_level" label="Template Level" size="small"
                                    options={templateLevelOptions} control={control} sortOptions={false} />
                            </FieldFocusPopup>
                        </Grid>
                        {/* CS-1518 END */}
                    </Grid>

                    {/* CS-1518 START */}
                    {showTemplatesTab && (
                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            <Grid item md={6}>
                                <Box sx={{ mx: -2.8 }}>
                                    <SectionHeader icon={<DescriptionOutlined fontSize="small" />} title="Manufacturer Templates" />
                                </Box>
                            </Grid>
                            <Grid item md={6}>
                                <Box sx={{ display: "flex", justifyContent: "flex-end", pr: 1 }}>
                                    <IconDetailToolBar items={templateIconDetails} />
                                    {templateLevel === "Manufacturer" && (
                                        <Button
                                            startIcon={<AddCircleOutlineOutlined />}
                                            onClick={clickShowTemplatePopup}
                                            color="success"
                                            removeUpperCase
                                            sx={{
                                                ...primaryBtnSx,
                                                "& .MuiTypography-root": { color: "#fff", fontWeight: 700 },
                                                "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "#fff" },
                                            }}
                                        >
                                            {manufacturerTemplateRows?.length === 0 ? "Add" : "Add More"}
                                        </Button>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <CustomTable
                                    columns={templateColumns}
                                    rows={manufacturerTemplateRows}
                                    disablePagination={true}
                                    actionComponent={(row: any) =>
                                        manufacturerTemplateActionComponent(row)
                                    }
                                />
                            </Grid>
                        </Grid>
                    )}
                    {/* CS-1518 END */}

                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        <Grid item md={12} xs={12}>
                            <Box sx={{ mx: -2.8 }}>
                                <SectionHeader
                                    icon={<ShoppingCart fontSize="small" />}
                                    title={`Cart Options (${getCategoryDisplayLabel(allCodeTablesValuesMap, PRODUCT_CATEGORY.CONSERVATIVE)} Orders Only)`}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <ModernStyledRadio
                                controllerName="cartOption"
                                control={control}
                                defaultValue={!isEditing ? "Option 1" : ""}
                                options={cartOptions}
                                gridSize={{ xs: 12, sm: 6, md: 6 }}
                            />
                        </Grid>
                    </Grid>

                    {/* Stripe Configurations Section */}
                    {canAccessStripeConfig && (
                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            <>
                                <Grid item md={12} xs={12}>
                                    <Box sx={{ mx: -2.8 }}>
                                        <SectionHeader icon={<PaymentOutlined fontSize="small" />} title="Stripe Configurations" />
                                    </Box>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <Controller
                                        name="stripeConfig.stripe_integration"
                                        control={control}
                                        render={({ field }) => (
                                            <FieldFocusPopup
                                                enabled
                                                title="Stripe Integration"
                                                content="Enable or disable Stripe Integration."
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <SwitchTextTrack
                                                            {...field}
                                                            name={field.name}
                                                            checked={field.value || false}
                                                            onChange={(e) => field.onChange(e.target.checked)}
                                                            disabled={isStripeConfigReadOnly || (!canEditStripeConfig && isEditing)}
                                                            size="medium"
                                                        />
                                                    }
                                                    label="Stripe Integration"
                                                    labelPlacement="start"
                                                />
                                            </FieldFocusPopup>
                                        )}
                                    />
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    {/* CS-1672 - Enhanced Connected Account ID field with confirmation popups */}
                                    <FieldLabel disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || (!canEditStripeConfig && isEditing)}>Connected Account ID</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Connected Account ID"
                                        content="Enter the Stripe Connected Account ID used for processing payments."
                                        placement="top-start"
                                    >
                                        <CustomTextField
                                            control={control}
                                            controllerName="stripeConfig.connected_account_id"
                                            label="Connected Account ID"
                                            size="small"
                                            disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || (!canEditStripeConfig && isEditing)}
                                            rules={{
                                                validate: (value: any) => {
                                                    // Only validate if stripe integration is enabled and field is visible/editable
                                                    if (!stripeIntegrationEnabled) {
                                                        return true; // No validation required when stripe is disabled
                                                    }

                                                    const isFieldVisible = !isStripeConfigReadOnly &&
                                                        (canEditStripeConfig || !isEditing);

                                                    if (isFieldVisible && (!value || value.trim() === "")) {
                                                        return "Connected Account ID is required.";
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                    {/* CS-1672 END */}
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || (!canEditStripeConfig && isEditing)}>Payment Method</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Payment Method"
                                        content="Select one or more payment methods to enable for transactions."
                                        placement="top-start"
                                    >
                                        <CustomMultipleDropDown
                                            name="stripeConfig.payment_method"
                                            label="Payment Method"
                                            size="small"
                                            options={paymentMethodsOptions}
                                            control={control}
                                            disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || (!canEditStripeConfig && isEditing)}
                                            rules={{
                                                validate: (value: any) => {
                                                    // Only validate if stripe integration is enabled and field is visible/editable
                                                    if (!stripeIntegrationEnabled || isStripeConfigReadOnly || (!canEditStripeConfig && isEditing)) {
                                                        return true; // No validation required when stripe is disabled or field is not visible/editable
                                                    }

                                                    if (!value || (Array.isArray(value) && value.length === 0)) {
                                                        return "At least one Payment Method is required.";
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldFocusPopup
                                        enabled
                                        title="Platform Fee Applicable"
                                        content="Enable or disable the application of a platform fee for transactions."
                                    >
                                        <Controller
                                            name="stripeConfig.platform_fee_applicable"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <SwitchTextTrack
                                                            {...field}
                                                            name={field.name}
                                                            checked={field.value || false}
                                                            onChange={(e) => field.onChange(e.target.checked)}
                                                            disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || (!canEditStripeConfig && isEditing)}
                                                            size="medium"
                                                        />
                                                    }
                                                    label="Platform Fee Applicable"
                                                    labelPlacement="start"
                                                />
                                            )}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || !paymentFeeApplicable || (!canEditStripeConfig && isEditing)}>Platform Fee Card (%)</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Platform Fee Card (%)"
                                        content="Enter the percentage-based platform fee applied to card transactions."
                                        placement="top-start"
                                    >
                                        <CustomNumberField
                                            control={control}
                                            controllerName="stripeConfig.platform_fee_card_percent"
                                            label="Platform Fee Card (%)"
                                            size="small"
                                            allowDecimal={true}
                                            allowNegative={false}
                                            disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || !paymentFeeApplicable || (!canEditStripeConfig && isEditing)}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (value === null || value === undefined || value === '') return true;

                                                    // Remove commas and parse the number
                                                    const cleanValue = typeof value === 'string' ? value.replace(/,/g, '') : value;
                                                    const numValue = parseFloat(cleanValue);

                                                    if (isNaN(numValue)) return "Please enter a valid number";
                                                    if (numValue < 0) return "Value must be 0 or greater";
                                                    if (numValue > 100) return "Percentage cannot exceed 100";

                                                    return true;
                                                }
                                            }}
                                            decimalScale={2}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || !paymentFeeApplicable || (!canEditStripeConfig && isEditing)}>Platform Fee Card Additional ($)</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Platform Fee Card Additional ($)"
                                        content="Enter any additional fixed platform fee applied to card transactions."
                                        placement="bottom-start"
                                    >
                                        <CustomCurrencyField
                                            control={control}
                                            controllerName="stripeConfig.platform_fee_card_additional"
                                            label="Platform Fee Card Additional ($)"
                                            size="small"
                                            disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || !paymentFeeApplicable || (!canEditStripeConfig && isEditing)}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (value === null || value === undefined || value === '') return true;

                                                    // Remove commas and parse the number
                                                    const cleanValue = typeof value === 'string' ? value.replace(/,/g, '') : value;
                                                    const numValue = parseFloat(cleanValue);

                                                    if (isNaN(numValue)) return "Please enter a valid amount";
                                                    if (numValue < 0) return "Value must be 0 or greater";

                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || !paymentFeeApplicable || (!canEditStripeConfig && isEditing)}>Platform Fee ACH (%)</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Platform Fee ACH (%)"
                                        content="Enter the percentage-based platform fee applied to ACH transactions."
                                        placement="left-start"
                                    >
                                        <CustomNumberField
                                            control={control}
                                            controllerName="stripeConfig.platform_fee_us_bank_account_percent"
                                            label="Platform Fee ACH (%)"
                                            size="small"
                                            allowDecimal={true}
                                            allowNegative={false}
                                            disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || !paymentFeeApplicable || (!canEditStripeConfig && isEditing)}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (value === null || value === undefined || value === '') return true;

                                                    // Remove commas and parse the number
                                                    const cleanValue = typeof value === 'string' ? value.replace(/,/g, '') : value;
                                                    const numValue = parseFloat(cleanValue);

                                                    if (isNaN(numValue)) return "Please enter a valid number";
                                                    if (numValue < 0) return "Value must be 0 or greater";
                                                    if (numValue > 100) return "Percentage cannot exceed 100";

                                                    return true;
                                                }
                                            }}
                                            decimalScale={2}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || !paymentFeeApplicable || (!canEditStripeConfig && isEditing)}>Platform Fee ACH Max Charge ($)</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Platform Fee ACH Max Charge ($)"
                                        content="Enter the maximum platform fee that can be charged for ACH transactions."
                                        placement="right-start"
                                    >
                                        <CustomCurrencyField
                                            control={control}
                                            controllerName="stripeConfig.platform_fee_us_bank_account_max_charge"
                                            label="Platform Fee ACH Max Charge ($)"
                                            size="small"
                                            disabled={isStripeConfigReadOnly || !stripeIntegrationEnabled || !paymentFeeApplicable || (!canEditStripeConfig && isEditing)}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (value === null || value === undefined || value === '') return true;

                                                    // Remove commas and parse the number
                                                    const cleanValue = typeof value === 'string' ? value.replace(/,/g, '') : value;
                                                    const numValue = parseFloat(cleanValue);

                                                    if (isNaN(numValue)) return "Please enter a valid amount";
                                                    if (numValue < 0) return "Value must be 0 or greater";

                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                            </>
                        </Grid>
                    )}

                    {/* NetSuite Configurations Section */}
                    {canAccessNetsuiteConfig && (
                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            <>
                                <Grid item md={12} xs={12}>
                                    <Box sx={{ mx: -2.8 }}>
                                        <SectionHeader icon={<CloudSyncOutlined fontSize="small" />} title="NetSuite Configurations" />
                                    </Box>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldFocusPopup
                                        enabled
                                        title="NetSuite Integration"
                                        content="Enable or disable integration with NetSuite."
                                    >
                                        <Controller
                                            name="netsuiteConfig.netsuite_integration"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <SwitchTextTrack
                                                            {...field}
                                                            name={field.name}
                                                            checked={field.value || false}
                                                            onChange={(e) => field.onChange(e.target.checked)}
                                                            disabled={isNetsuiteConfigReadOnly}
                                                            size="medium"
                                                        />
                                                    }
                                                    label="NetSuite Integration"
                                                    labelPlacement="start"
                                                />
                                            )}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel>Connected Customer ID</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Connected Customer ID"
                                        content="Enter the NetSuite Connected Customer ID for this account."
                                        placement="top-start"
                                    >
                                        <CustomNumberField
                                            control={control}
                                            controllerName="netsuiteConfig.connected_customer_id"
                                            label="Connected Customer ID"
                                            size="small"
                                            allowDecimal={true}
                                            allowNegative={false}
                                            disabled={isNetsuiteConfigReadOnly}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (watch('netsuiteConfig.netsuite_integration') && !value) {
                                                        return "Consumer ID is required.";
                                                    }
                                                    return true;
                                                }
                                            }}
                                        // decimalScale={2}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel>Consumer Key</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Consumer Key"
                                        content="Enter the NetSuite Consumer Key for authentication."
                                        placement="top-start"
                                    >
                                        <CustomTextField
                                            control={control}
                                            controllerName="netsuiteConfig.consumer_key"
                                            label="Consumer Key"
                                            size="small"
                                            disabled={isNetsuiteConfigReadOnly}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (watch('netsuiteConfig.netsuite_integration') && (!value || value.trim() === "")) {
                                                        return "Consumer Key is required.";
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel>Consumer Secret</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Consumer Secret"
                                        content="Enter the NetSuite Consumer Secret for authentication."
                                        placement="left-start"
                                    >
                                        <CustomTextField
                                            control={control}
                                            controllerName="netsuiteConfig.consumer_secret"
                                            label="Consumer Secret"
                                            size="small"
                                            disabled={isNetsuiteConfigReadOnly}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (watch('netsuiteConfig.netsuite_integration') && (!value || value.trim() === "")) {
                                                        return "Consumer Secret is required.";
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel>Access Token</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Access Token"
                                        content="Enter the NetSuite Access Token for API access."
                                        placement="top-start"
                                    >
                                        <CustomTextField
                                            control={control}
                                            controllerName="netsuiteConfig.access_token"
                                            label="Access Token"
                                            size="small"
                                            disabled={isNetsuiteConfigReadOnly}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (watch('netsuiteConfig.netsuite_integration') && (!value || value.trim() === "")) {
                                                        return "Access Token is required.";
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel>Token Secret</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Token Secret"
                                        content="Enter the NetSuite Token Secret associated with the Access Token."
                                        placement="top-start"
                                    >
                                        <CustomTextField
                                            control={control}
                                            controllerName="netsuiteConfig.token_secret"
                                            label="Token Secret"
                                            size="small"
                                            disabled={isNetsuiteConfigReadOnly}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (watch('netsuiteConfig.netsuite_integration') && (!value || value.trim() === "")) {
                                                        return "Token Secret is required.";
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel>Realm</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Realm"
                                        content="Enter the NetSuite account realm (account ID)."
                                        placement="left-start"
                                    >
                                        <CustomTextField
                                            control={control}
                                            controllerName="netsuiteConfig.realm"
                                            label="Realm"
                                            size="small"
                                            disabled={isNetsuiteConfigReadOnly}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (watch('netsuiteConfig.netsuite_integration') && (!value || value.trim() === "")) {
                                                        return "Realm is required.";
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                    <FieldLabel>Post Sales Order API URL</FieldLabel>
                                    <FieldFocusPopup
                                        enabled
                                        title="Post Sales Order API URL"
                                        content="Enter the API endpoint URL for posting sales orders to NetSuite."
                                        placement="right-start"
                                    >
                                        <CustomTextField
                                            control={control}
                                            controllerName="netsuiteConfig.post_sales_order_api_url"
                                            label="Post Sales Order API URL"
                                            size="small"
                                            disabled={isNetsuiteConfigReadOnly}
                                            rules={{
                                                validate: (value: any) => {
                                                    if (watch('netsuiteConfig.netsuite_integration') && (!value || value.trim() === "")) {
                                                        return "Post Sales Order API URL is required.";
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </FieldFocusPopup>
                                </Grid>
                            </>
                        </Grid>
                    )}

                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                                <Grid item md={12} xs={12}>
                            <Box
                                sx={{
                                    mx: -2.8,
                                    display: "grid",
                                    gridTemplateColumns: {
                                        xs: "1fr",
                                        md: canAccessPharmacyConfig ? "1fr 1fr 1fr" : "1fr",
                                    },
                                    columnGap: 2,
                                    rowGap: 1.5,
                                }}
                            >
                                {canAccessPharmacyConfig && (
                                    <SectionHeader
                                        icon={<AccountTreeOutlined fontSize="small" />}
                                        title="Allow Multi Product Agreement"
                                    />
                                )}
                                {canAccessPharmacyConfig && (
                                    <SectionHeader icon={<LocalPharmacyOutlined fontSize="small" />} title="Pharmacy Configurations" />
                                )}
                                {canAccessPharmacyConfig && (
                                    <SectionHeader icon={<DescriptionOutlined fontSize="small" />} title="Bill To" />
                                )}
                                {canAccessPharmacyConfig && (
                                    <FieldFocusPopup
                                        enabled
                                        title="Allow Multi Product Agreement"
                                        content="Turn this on to allow multi-product agreements for this manufacturer's Purchase & Bill Mandatory products. Leave off to keep single agreement create only."
                                    >
                                        <Box>
                                            <Controller
                                                name="agreementGrouping"
                                                control={control}
                                                render={({ field }) => (
                                                    <FormControlLabel
                                                        control={
                                                            <SwitchTextTrack
                                                                {...field}
                                                                name={field.name}
                                                                checked={field.value || false}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    if (checked && !manufacturerHasLiveServiceAgreement) {
                                                                        rejectAgreementGroupingWithoutLiveDocument();
                                                                        field.onChange(false);
                                                                        return;
                                                                    }
                                                                    field.onChange(checked);
                                                                }}
                                                                size="medium"
                                                            />
                                                        }
                                                        label="Allow Multi Product Agreement"
                                                        labelPlacement="start"
                                                    />
                                                )}
                                            />
                                            {showAgreementGroupingLiveDocumentError && (
                                                <FormHelperText error data-testid="manufacturer-agreement-grouping-live-sa-error">
                                                    {MSG_NO_LIVE_SERVICE_AGREEMENT_FOR_MANUFACTURER}
                                                </FormHelperText>
                                            )}
                                        </Box>
                                    </FieldFocusPopup>
                                )}
                                {canAccessPharmacyConfig && (
                                    <FieldFocusPopup
                                        enabled
                                        title="Pharmacy"
                                        content="Turn this on when the manufacturer is an Rx pharmacy partner. Pharmacies are the entities prescriptions are submitted to, and only they appear in the pharmacy lists on the practice and Rx Request screens."
                                    >
                                        <Controller
                                            name="isPharmacy"
                                            control={control}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <SwitchTextTrack
                                                            {...field}
                                                            name={field.name}
                                                            checked={field.value || false}
                                                            onChange={(e) => {
                                                                const checked = e.target.checked;
                                                                field.onChange(checked);
                                                                if (checked) {
                                                                    setValue("pharmacyBillToDefault", "");
                                                                } else {
                                                                    setValue("pharmacyBillToDisplay", []);
                                                                    setValue("pharmacyBillToDefault", "");
                                                                    clearErrors(["pharmacyBillToDisplay", "pharmacyBillToDefault"]);
                                                                }
                                                            }}
                                                            size="medium"
                                                        />
                                                    }
                                                    label="isPharmacy"
                                                    labelPlacement="start"
                                                />
                                            )}
                                        />
                                    </FieldFocusPopup>
                                )}
                                {canAccessPharmacyConfig && (
                                    <FieldFocusPopup
                                        enabled
                                        title="Bill To"
                                        content="Choose which Bill To options appear on Rx requests for this pharmacy. Turn on isPharmacy first. At least one option is required. Default is optional and pre-selects Bill To on new Rx requests when set."
                                        placement="top"
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 1,
                                                minHeight: 48,
                                                justifyContent: "center",
                                                ...billToControlsSx,
                                                ...billToControlsSxWhenDisabled,
                                            }}
                                        >
                                    <Controller
                                        name="pharmacyBillToDisplay"
                                        control={control}
                                        defaultValue={[]}
                                        rules={{
                                            validate: (value) => {
                                                if (!getValues("isPharmacy")) return true;
                                                return (
                                                    (Array.isArray(value) && value.length > 0) ||
                                                    "Select at least one Bill To option."
                                                );
                                            },
                                        }}
                                        render={({ field, fieldState }) => (
                                            <>
                                            <FieldLabel required disabled={billToFieldsDisabled}>Options</FieldLabel>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    columnGap: 2,
                                                    rowGap: 0.5,
                                                    alignItems: "center",
                                                }}
                                            >
                                                {pharmacyBillToOptions.map((option) => (
                                                    <FormControlLabel
                                                        key={option.value}
                                                        disabled={billToFieldsDisabled}
                                                        control={
                                                            <Checkbox
                                                                color={pharmacyBillToControlColor(theme.palette.mode)}
                                                                size="medium"
                                                                disabled={billToFieldsDisabled}
                                                                checked={(field.value || []).includes(option.value)}
                                                                onChange={(e) => {
                                                                    const current: string[] = field.value || [];
                                                                    const next = e.target.checked
                                                                        ? [...current, option.value]
                                                                        : current.filter((value) => value !== option.value);
                                                                    field.onChange(next);
                                                                    const selectedDefault = getValues("pharmacyBillToDefault");
                                                                    if (selectedDefault && !next.includes(selectedDefault)) {
                                                                        setValue("pharmacyBillToDefault", "");
                                                                    }
                                                                    if (next.length === 1) {
                                                                        setValue("pharmacyBillToDefault", next[0]);
                                                                    }
                                                                    void trigger("pharmacyBillToDisplay");
                                                                }}
                                                            />
                                                        }
                                                        label={option.label}
                                                        sx={{
                                                            mr: 0,
                                                            "& .MuiFormControlLabel-label": {
                                                                fontSize: "0.85rem",
                                                                fontWeight: 600,
                                                                color: mTokens.textPrimary,
                                                            },
                                                        }}
                                                    />
                                                ))}
                                            </Box>
                                            {!billToFieldsDisabled && fieldState.error?.message && (
                                                <FormHelperText error sx={{ mx: 0, mt: -0.25 }}>
                                                    {fieldState.error.message}
                                                </FormHelperText>
                                            )}
                                            </>
                                        )}
                                    />
                                            <Box>
                                                <FieldLabel disabled={billToFieldsDisabled}>Default</FieldLabel>
                                                <Controller
                                                    name="pharmacyBillToDefault"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <RadioGroup
                                                            row
                                                            name={field.name}
                                                            value={field.value ?? ""}
                                                            onChange={(e) => {
                                                                if (billToFieldsDisabled) return;
                                                                field.onChange(e.target.value);
                                                            }}
                                                            sx={{
                                                                flexWrap: "wrap",
                                                                columnGap: 2,
                                                                rowGap: 0.5,
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            {pharmacyBillToOptions
                                                                .filter((option) =>
                                                                    pharmacyBillToDisplay.includes(option.value)
                                                                )
                                                                .map((option) => (
                                                                    <FormControlLabel
                                                                        key={option.value}
                                                                        value={option.value}
                                                                        disabled={billToFieldsDisabled}
                                                                        control={
                                                                            <Radio
                                                                                color={pharmacyBillToControlColor(
                                                                                    theme.palette.mode
                                                                                )}
                                                                                size="medium"
                                                                                disabled={billToFieldsDisabled}
                                                                            />
                                                                        }
                                                                        label={option.label}
                                                                        sx={{
                                                                            mr: 0,
                                                                            "& .MuiFormControlLabel-label": {
                                                                                fontSize: "0.85rem",
                                                                                fontWeight: 600,
                                                                                color: mTokens.textPrimary,
                                                                            },
                                                                        }}
                                                                    />
                                                                ))}
                                                        </RadioGroup>
                                                    )}
                                                />
                                            </Box>
                                        </Box>
                                    </FieldFocusPopup>
                                )}
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid
                        mt={2}
                        container
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={1}
                    >
                        <Grid item xs={12} md="auto">
                            <Button
                            fullWidth
                            type="submit"
                            removeUpperCase
                            startIcon={<SaveOutlined />}
                            sx={{
                                ...primaryBtnSx,
                                "& .MuiTypography-root": { color: "#fff", fontWeight: 700 },
                                "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "#fff" },
                            }}
                            >
                                {isEditing ? "Update Manufacturer" : "Create Manufacturer"}
                            </Button>
                        </Grid>
                        <Grid item xs={12} md="auto">
                            <Button
                                fullWidth
                                variant="outlined"
                                removeUpperCase
                                startIcon={<CancelOutlined sx={{ fontSize: "1rem !important" }} />}
                                onClick={() => onClose()}
                                sx={{
                                    ...cancelBtnSx,
                                    "& .MuiTypography-root": { color: "inherit", fontWeight: 700 },
                                    "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "inherit" },
                                }}>
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                    </Box>
                </form>
            </Box>

            {/* CS-1518 START */}
            <PracticeTemplatePopup
                open={showTemplatePopup}
                onClose={clickCloseTemplatePopup}
                onAdd={addManufacturerTemplate}
                onSuccess={() => {
                    // Refresh manufacturer templates after success
                    if (ManufacturerData?.manufacturerId) {
                        dispatch(fetchManufacturerTemplatesData(ManufacturerData.manufacturerId.toString()));
                    }
                }}
                manufacturerId={ManufacturerData?.manufacturerId}
                editData={templateEditData}
                isEditMode={isTemplateEditMode}
                mode="manufacturer"
            />

            <OptionsPopup
                open={showTemplateLevelWarning}
                onClose={() => setShowTemplateLevelWarning(false)}
                variant="warning"
                message="Changing the template level will inactivate all existing active templates. Do you want to continue?"
                buttons={[
                    {
                        name: "Yes",
                        color: "primary",
                        onClick: handleTemplateLevelChange,
                    },
                    {
                        name: "Cancel",
                        color: "secondary",
                        onClick: cancelTemplateLevelChange,
                    },
                ]}
            />

            <OptionsPopup
                open={showOptionsPopup.show}
                onClose={() => setShowOptionsPopup({ message: "", show: false })}
                variant={showOptionsPopup.variant || "confirm"}
                message={showOptionsPopup.message}
                buttons={showOptionsPopup.buttons || []}
            />
            {/* CS-1518 END */}
        </Box>
    );
};

export default CreateMaufacturer;
